// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__3H3F1","footer":"ModalFilter_footer__10UdR"};